"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function GuidesPreview() {
  const {
    ref: containerRef,
    isVisible: containerVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: button1Ref,
    isVisible: button1Visible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: button2Ref,
    isVisible: button2Visible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section className="relative overflow-hidden bg-dark-background py-24 px-6 md:px-12 lg:px-24">
      <div className="mx-auto max-w-7xl">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {}
          <div ref={containerRef} className={`space-y-6 transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${containerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
            <h2 className="font-display text-4xl md:text-5xl font-bold text-foreground-dark leading-tight">
              Download Our{" "}
              <span className="text-primary">Expert Guides</span>
            </h2>
            <p className="text-foreground-dark/80 text-lg leading-relaxed">
              Unlock proven strategies to eliminate administrative friction and
              reclaim your time. Get instant access to our comprehensive e-books
              designed specifically for dance studios and nonprofits.
            </p>
          </div>

          {}
          <div className="space-y-4">
            <div ref={button1Ref} className={`transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${button1Visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
              <Link to="/GuidesPage#systematic-studio">
                <Button size="lg" className="w-full h-auto py-6 px-8 bg-primary hover:bg-secondary text-foreground-primary font-display text-lg font-semibold rounded-lg shadow-medium transition-all duration-[80ms] hover:scale-[1.02] hover:shadow-strong focus-visible:ring-2 focus-visible:ring-primary">
                  The Systematic Studio
                </Button>
              </Link>
            </div>

            <div ref={button2Ref} className={`transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${button2Visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
              <Link to="/GuidesPage#npo-survival-guide">
                <Button size="lg" className="w-full h-auto py-6 px-8 bg-primary hover:bg-secondary text-foreground-primary font-display text-lg font-semibold rounded-lg shadow-medium transition-all duration-[80ms] hover:scale-[1.02] hover:shadow-strong focus-visible:ring-2 focus-visible:ring-primary">
                  The NPO Survival Guide
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>;
}